import { useBreakpoint } from '@contexts/device';

export const useLayout = (): 'column' | 'row' => {
  const screens = useBreakpoint();
  const { xl, xxl, lg } = screens;
  return lg || xl || xxl ? 'row' : 'column';
};

export const useScreenSize = () => {
  return useLayout() === 'column' ? 'small' : 'large';
};

export type ResponsiveSizes = {
  small: number;
  large: number;
};
export const useSizes = (sizes: ResponsiveSizes) => {
  return sizes[useScreenSize()];
};

const defaultResponsiveInputHeightConfig = {
  large: 68,
  small: 68,
};

const defaultResponsiveInputLabelConfig = {
  large: 15,
  small: 10,
};

export const useHeight = (heights = defaultResponsiveInputHeightConfig) =>
  useSizes(heights);
export const useLabelTop = (labelTops = defaultResponsiveInputLabelConfig) =>
  useSizes(labelTops);
